import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { EDITOR_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-editor-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated_stale__/onboardingStateGetOnboardingStateQuery.graphql.ts';

export const preloadEditorOnboardingState = (): Promise<{
	data: unknown;
	hasErrors: boolean;
}> => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: Object.values(EDITOR_ONBOARDING_STATE_KEYS),
		},
	});
};
